import converter from './measurementConversions';
import isLegacyOrder from './isLegacyOrder';

const dimensionPrefixes = ['one', 'two', 'three', 'four', 'five'];

export const itemVolume = (item) => {
    if (item.dimensions_as_ranges) {
        const [minLength, maxLength] = converter.inToFt(item.length);
        const [minWidth, maxWidth] = converter.inToFt(item.width);
        const [minHeight, maxHeight] = converter.inToFt(item.height);

        const minVolume = +(minLength * minWidth * minHeight).toFixed(2);
        const maxVolume = +(maxLength * maxWidth * maxHeight).toFixed(2);

        return [minVolume, maxVolume];
    }

    const length = converter.inToFt(+item.length);
    const width = converter.inToFt(+item.width);
    const height = converter.inToFt(+item.height);
    const volume = +parseFloat(length * width * height).toFixed(2);

    return volume;
};

const calculateLegacyVolume = (order) => {
    return dimensionPrefixes.reduce((acc, prefix) => {
        const length = converter.inToFt(+order[`${prefix}_length`]);
        const width = converter.inToFt(+order[`${prefix}_width`]);
        const height = converter.inToFt(+order[`${prefix}_height`]);
        const volume = +parseFloat(length * width * height).toFixed(0);

        if (volume && volume > 0) {
            return acc + volume;
        }

        return acc;
    }, 0);
};

const calculateNewVolume = (order) => {
    if (!order.items) {
        return;
    }

    const itemValues = Object.values(order.items);

    return itemValues.reduce((acc, item) => {
        const length = converter.inToFt(+item.length);
        const width = converter.inToFt(+item.width);
        const height = converter.inToFt(+item.height);
        const volume = +parseFloat(length * width * height).toFixed(0);

        if (volume && volume > 0) {
            return acc + volume;
        }

        return acc;
    }, 0);
};

export default function calculateVolume(order, isLegacy) {
    if (isLegacy === undefined) {
        isLegacy = isLegacyOrder(order);
    }

    if (isLegacy) {
        return calculateLegacyVolume(order);
    }

    return calculateNewVolume(order);
}
